<p-button
  [label]="lockId ? 'Unlock' : 'Lock'"
  [icon]="lockId ? 'pi pi-unlock' : 'pi pi-lock'"
  [styleClass]="lockId ? 'p-button-success' : 'p-button-danger'"
  [loading]="isLoading"
  (click)="onClick()"
  >
</p-button>
